<mat-card class="register-form">
  <mat-card-header>
    <mat-card-title>Make password</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div>
      <div class="example-loading-shade" *ngIf="loading">
        <mat-spinner></mat-spinner>
      </div>
      <form [formGroup]="form">
        <p>
          <mat-form-field appearance="fill" class="fields-form">
            <mat-label>Enter your password</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="password1">
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error>{{ getFieldPass1Error() }}</mat-error>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field appearance="fill" class="fields-form">
            <mat-label>Repeat your password</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="password2">
            <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
            <mat-error>{{ getFieldPass2Error() }}</mat-error>
          </mat-form-field>
        </p>
      </form>
    </div>
  </mat-card-content>
  <mat-card-actions align="end">
    <button [disabled]="loading" mat-button (click)="onSubmit()">{{ "Save" | translate }}</button>
  </mat-card-actions>
</mat-card>
<app-alert></app-alert>

